// path: /chat/openAIUtils.jsx
import OpenAI from "openai";

// Mapping of assistant titles to their respective API keys
const assistantApiKeyMap = {
  'Nur Al Huda': process.env.REACT_APP_OPENAI_API_KEY_NUR_ALHUDA,
  'Nur Al Huda For Kids': process.env.REACT_APP_OPENAI_API_KEY_NUR_ALHUDA_FOR_KIDS,
  'Islamic Socratic Method': process.env.REACT_APP_OPENAI_API_KEY_ISLAMIC_SOCRATIC_METHOD,
  'Iqra With Us': process.env.REACT_APP_OPENAI_API_KEY_IQRA_WITH_US,
  'AI for Islamic Research': process.env.REACT_APP_OPENAI_API_KEY_AI_FOR_ISLAMIC_RESEARCH,
  'Muslim Reference AI': process.env.REACT_APP_OPENAI_API_KEY_MUSLIM_REFERENCE_AI,
  'PaliGPT': process.env.REACT_APP_OPENAI_API_KEY_NUR_ALHUDA,
  'Quiz Generator': process.env.REACT_APP_OPENAI_API_KEY_NUR_ALHUDA,
  'Auto Grader' : process.env.REACT_APP_OPENAI_API_KEY_NUR_ALHUDA,
  '5D Thinking': process.env.REACT_APP_OPENAI_API_KEY_NUR_ALHUDA,
  '5D Thinking-1': process.env.REACT_APP_OPENAI_API_KEY_NUR_ALHUDA,
  '5D Thinking-2': process.env.REACT_APP_OPENAI_API_KEY_NUR_ALHUDA,
  'Slide Generator': process.env.REACT_APP_OPENAI_API_KEY_NUR_ALHUDA
};

// Add PaliGPT resource-specific API keys
// openAIUtils.jsx  (or wherever you keep the helper)
const paliGPTApiKeyMap = {
    // existing 000‑005
    'asst_ShMxEdN8gnWONFOVVFv8dKTJ': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_000,
    'asst_OYEGqG4j2LJizAd29TNWdKeU': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_001,
    'asst_ORtx8UWdX8OjsLVT0JdLp0vw': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_002,
    'asst_GqX0ylTRKsIbW1uvKUjFJZsV': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_003,
    'asst_5OXfkaIGuml5MPuy2KZ8biIt': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_004,
    'asst_hNfWQd70TWGinBafH2FsQ7rX': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_005,
  
    'asst_hA8Upi4LRK0lgXLUhg7nY27F': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_006,
    'asst_jfoDjwt109x2Vxp4HGuJk7G2': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_007,
    'asst_8FkKzcAkXKx59TM1LycUYzPo': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_008,
    'asst_ZoUG2bupxV084bK0ssE40zmZ': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_009,
    'asst_hjoblnVjAVIeJhRBseh0rpy4': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_010,

    'asst_nzfXwZFSZSGgQJ7RtPjchhpc': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_011,
    'asst_PhFJXE6Ro3cmSFLwD8JDTns8': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_012,
    'asst_OSRuLPes9hsJ7Ya1Gffp5Vd1': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_013,
    'asst_jRiALzOTWRCLcFHD2EqF675J': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_014,
    'asst_1nLkSC1NUgHANvLpC3blG3qV': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_015,
    'asst_pV52eC8FVs8v3bAf2ObbTjVk': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_016

};
  

// Function to initialize OpenAI client with the appropriate API key
export function initializeOpenAIClient(assistantTitle, resourceId = null) {
  console.log('Initializing OpenAI client with:', { assistantTitle, resourceId });
  let apiKey;
  
  // If it's PaliGPT and we have a resourceId, use the resource-specific API key
  if (assistantTitle === 'PaliGPT' && resourceId) {
    console.log('Attempting to use PaliGPT resource-specific key for:', resourceId);
    apiKey = paliGPTApiKeyMap[resourceId];
    console.log('PaliGPT API key found:', !!apiKey);
  }
  
  // If no resource-specific key found, try the assistant-specific key
  if (!apiKey) {
    console.log('Falling back to assistant-specific key for:', assistantTitle);
    apiKey = assistantApiKeyMap[assistantTitle];
    console.log('Assistant-specific API key found:', !!apiKey);
  }

  // Validate API key
  if (!apiKey) {
    console.error('No API key found for:', { assistantTitle, resourceId });
    console.log('Available assistant titles:', Object.keys(assistantApiKeyMap));
    if (assistantTitle === 'PaliGPT') {
      console.log('Available PaliGPT resource IDs:', Object.keys(paliGPTApiKeyMap));
    }
    throw new Error(`No API key found for ${assistantTitle}${resourceId ? ` with resource ${resourceId}` : ''}`);
  }

  console.log('Successfully initialized OpenAI client');
  return new OpenAI({
    apiKey: apiKey,
    dangerouslyAllowBrowser: true,
  });
}

let currentStream = null;

// Helper function for retry logic with exponential backoff
async function withRetry(asyncFunc, args = [], maxRetries = 3, baseDelay = 1000) {
  let attempt = 0;
  while (attempt <= maxRetries) {
    try {
      return await asyncFunc(...args);
    } catch (error) {
      if (attempt < maxRetries) {
        const retryDelay = baseDelay * Math.pow(2, attempt); // Exponential backoff
        console.warn(`Attempt ${attempt + 1} failed. Retrying after ${retryDelay}ms...`);
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
        attempt++;
      } else {
        console.error(`All ${maxRetries + 1} attempts failed.`);
        throw error;
      }
    }
  }
}

export async function createThread(assistantTitle, resourceId = null) {
  console.log('Creating new thread for:', { assistantTitle, resourceId });
  const openai = initializeOpenAIClient(assistantTitle, resourceId);
  try {
    console.log('Attempting to create thread...');
    const thread = await withRetry(() => openai.beta.threads.create());
    console.log('Thread created successfully:', thread.id);
    return thread;
  } catch (error) {
    console.error("Error creating thread:", error);
    console.error("Error details:", {
      message: error.message,
      status: error.status,
      type: error.type
    });
    throw error;
  }
}

export async function createMessage(threadId, newMessage, assistantTitle, resourceId = null) {
  console.log('Creating message in thread:', { threadId, assistantTitle, resourceId });
  const openai = initializeOpenAIClient(assistantTitle, resourceId);
  try {
    console.log('Attempting to send message...');
    const response = await withRetry(() =>
      openai.beta.threads.messages.create(threadId, {
        role: "user",
        content: newMessage,
      })
    );
    console.log('Message sent successfully:', response.id);
    return response;
  } catch (error) {
    console.error("Error sending message to thread:", error);
    console.error("Error details:", {
      message: error.message,
      status: error.status,
      type: error.type
    });
    throw error;
  }
}

export function createRun(threadId, assistantId, handleMessage, handleError, assistantTitle, resourceId = null) {
  console.log('Creating run:', { threadId, assistantId, assistantTitle, resourceId });
  
  if (currentStream) {
    console.warn("A stream is already active, aborting new run initiation.");
    return;
  }

  const openai = initializeOpenAIClient(assistantTitle, resourceId);

  const runStream = () => {
    console.log('Initiating stream for run...');
    return new Promise((resolve, reject) => {
      try {
        currentStream = openai.beta.threads.runs
          .stream(threadId, {
            assistant_id: assistantId,
          })
          .on("textDelta", (textDelta) => {
            console.log('Received text delta:', textDelta.value ? textDelta.value.length : 0, 'characters');
            if (textDelta.value) {
              handleMessage({ sender: "assistant", text: textDelta.value });
            }
          })
          .on("end", () => {
            console.log('Stream ended successfully');
            handleMessage({ sender: "assistant", text: "END_TOKEN" });
            currentStream = null;
            resolve();
          })
          .on("error", (error) => {
            console.error("Stream error:", error);
            console.error("Stream error details:", {
              message: error.message,
              status: error.status,
              type: error.type
            });
            currentStream = null;
            reject(error);
          });
      } catch (error) {
        console.error("Error initiating run with assistant:", error);
        console.error("Error details:", {
          message: error.message,
          status: error.status,
          type: error.type
        });
        currentStream = null;
        reject(error);
      }
    });
  };

  console.log('Starting run with retry logic...');
  withRetry(runStream)
    .then(() => {
      console.log('Run completed successfully');
    })
    .catch((error) => {
      console.error('Run failed after all retries:', error);
      if (handleError) {
        handleError(error);
      }
    });
}

export async function createRunNoStream(threadId, assistantId, assistantTitle, resourceId = null) {
  const openai = initializeOpenAIClient(assistantTitle, resourceId);
  try {
    const runResponse = await withRetry(() =>
      openai.beta.threads.runs.create(threadId, {
        assistant_id: assistantId,
      })
    );
    return runResponse;
  } catch (error) {
    console.error("Error initiating run with assistant:", error);
    throw error;
  }
}

export async function getRunStatus(threadId, runId, assistantTitle, resourceId = null) {
  const openai = initializeOpenAIClient(assistantTitle, resourceId);
  try {
    const runStatus = await withRetry(() =>
      openai.beta.threads.runs.retrieve(threadId, runId)
    );
    return runStatus;
  } catch (error) {
    console.error("Error retrieving run status:", error);
    throw error;
  }
}

export const titleToAssistantIDMap = {
  'Nur Al Huda': "asst_0UOsgGXyWL19iwxrR1tqt56p",
  'Nur Al Huda For Kids': "asst_2z9CBAnU88vgmSnZnNHZVaGz",
  'Islamic Socratic Method': "asst_nUrppuSP9pPPjRPHDD3l13bH",
  'Iqra With Us': "asst_NSjlngEyPNwU1PeAcmZZHC9K",
  'Muslim Reference AI': "asst_gJad0rJeSMH3s4Uo9oTWjE9y",
  'PaliGPT': "asst_ShMxEdN8gnWONFOVVFv8dKTJ",
  'Quiz Generator': "asst_paDb8Yr8jvqDUmFd2q4n1Fbi",
  'Auto Grader': "asst_6RiVocNQqbUn9lyeC3aZsde3",
  '5D Thinking' : "asst_7tVLODKXgClbyXhQCv89DW3w",
  '5D Thinking-1': "asst_zjjLJ9DjptDuCCgwA9uTO51z",
  '5D Thinking-2': "asst_RanK2BnaspTIIM5BqsVvasK5",
  'Slide Generator': "asst_ts7eHBFDcdcMgNeshbNShuvy",
};
